(() => {
  if (document.documentElement.dataset.storeCleanCta) return;
  document.documentElement.dataset.storeCleanCta = 'true';
  const interactive = 'a,button,[role="button"]';
  const functional = 'summary,[aria-expanded],.pagination a,.pagination button,.slider-button,.flickity-prev-next-button,[data-carousel-next],[data-carousel-prev],[data-gallery-next],[data-gallery-prev],[data-keep-arrow]';
  const arrows = /[↗↖↘↙→↓⟶➜➔]/g;
  const hasArrow = value => /[↗↖↘↙→↓⟶➜➔]/.test(value || '');
  const arrowIcons = '[data-store-icon="arrow"],svg[class*="arrow-up-right"],svg[class*="arrow-top-right"],svg[class*="arrow-right"],.st-link-arrow';
  const hide = element => {
    if (!element.hasAttribute('data-store-clean-arrow')) element.setAttribute('data-store-clean-arrow', '');
  };
  const clean = element => {
    if (!element || element.matches(functional)) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement.closest('svg,script,style,template,.sr-only,.visually-hidden,[data-keep-arrow]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    const label = nodes.map(node => node.nodeValue).join('').replace(arrows, '').trim();
    if (!/[\p{L}\p{N}]/u.test(label)) return;
    nodes.forEach(node => {
      if (!hasArrow(node.nodeValue)) return;
      node.nodeValue = node.nodeValue.replace(arrows, '').replace(/[ \t]+$/, '');
      const parent = node.parentElement;
      if (parent !== element && !parent.textContent.trim() && !parent.querySelector('img,svg,input,video')) hide(parent);
    });
    element.querySelectorAll(arrowIcons).forEach(hide);
    ['before', 'after'].forEach(side => {
      if (hasArrow(getComputedStyle(element, '::' + side).content)) element.classList.add('store-clean-' + side);
    });
  };
  const scan = root => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(interactive)) clean(root);
    root.querySelectorAll(interactive).forEach(clean);
  };
  const start = () => {
    scan(document.body);
    new MutationObserver(records => {
      const changed = new Set();
      records.forEach(record => {
        const parent = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        const control = parent?.closest(interactive);
        if (control) changed.add(control);
        record.addedNodes.forEach(node => { if (node.nodeType === Node.ELEMENT_NODE) changed.add(node); });
      });
      changed.forEach(scan);
    }).observe(document.body, {childList:true, characterData:true, subtree:true});
    document.addEventListener('pointerover', event => clean(event.target.closest?.(interactive)), {passive:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
